var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlignmentLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.3125C7.5 4.9328 7.8078 4.625 8.1875 4.625H20.3125C20.6922 4.625 21 4.9328 21 5.3125V5.3125C21 5.6922 20.6922 6 20.3125 6H8.1875C7.8078 6 7.5 5.6922 7.5 5.3125V5.3125ZM7.5 9.75C7.5 9.33579 7.83579 9 8.25 9H17.25C17.6642 9 18 9.33579 18 9.75V9.75C18 10.1642 17.6642 10.5 17.25 10.5H8.25C7.83579 10.5 7.5 10.1642 7.5 9.75V9.75ZM7.5 14.25C7.5 13.8358 7.83579 13.5 8.25 13.5H20.25C20.6642 13.5 21 13.8358 21 14.25V14.25C21 14.6642 20.6642 15 20.25 15H8.25C7.83579 15 7.5 14.6642 7.5 14.25V14.25ZM7.5 18.75C7.5 18.3358 7.83579 18 8.25 18H17.25C17.6642 18 18 18.3358 18 18.75V18.75C18 19.1642 17.6642 19.5 17.25 19.5H8.25C7.83579 19.5 7.5 19.1642 7.5 18.75V18.75ZM3 3.675C3 3.30221 3.30221 3 3.675 3V3C4.04779 3 4.35 3.30221 4.35 3.675V20.325C4.35 20.6978 4.04779 21 3.675 21V21C3.30221 21 3 20.6978 3 20.325V3.675Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlignmentLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alignment-left.507d50d5a8f268d87c9b9b08a3215c04.svg";